import React from 'react';
import { ProgressBar } from 'react-bootstrap';
import './Skills.css'
const Skills = () => {
    return (
        <div className="container mb-4" id="skills">
            <h1 className="heading">Skills</h1>
            <div className="row">
                <div className="font-end col-lg-6">
                    <div>
                        <h1 className="front-end my-4">Front End</h1>
                        <div>
                            <div className="d-flex text-white justify-content-between">
                                <h1>HTML</h1>
                                <p>95%</p>
                            </div>
                            <ProgressBar animated now={95} />
                        </div>
                        <div>
                            <div className="d-flex text-white justify-content-between mt-4">
                                <h1>CSS3</h1>
                                <p>85%</p>
                            </div>
                            <ProgressBar animated now={85} />
                        </div>
                        <div>
                            <div className="d-flex text-white justify-content-between mt-4">
                                <h1>BOOTSTRAP</h1>
                                <p>91%</p>
                            </div>
                            <ProgressBar animated now={91} />
                        </div>
                        <div>
                            <div className="d-flex text-white justify-content-between mt-4">
                                <h1>TAILWINE</h1>
                                <p>80%</p>
                            </div>
                            <ProgressBar animated now={80} />
                        </div>
                        <div>
                            <div className="d-flex text-white justify-content-between mt-4">
                                <h1>REACT</h1>
                                <p>95%</p>
                            </div>
                            <ProgressBar animated now={95} />
                        </div>
                    </div>
                </div>
                <div className="back-end col-lg-6">
                <div>
                        <h1 className="front-end my-4">Back End</h1>
                        <div>
                            <div className="d-flex text-white justify-content-between">
                                <h1>JAVASCRIPT</h1>
                                <p>90%</p>
                            </div>
                            <ProgressBar animated now={90} />
                        </div>
                        <div>
                            <div className="d-flex text-white justify-content-between mt-4">
                                <h1>EXPRESSJS</h1>
                                <p>80%</p>
                            </div>
                            <ProgressBar animated now={80} />
                        </div>
                        <div>
                            <div className="d-flex text-white justify-content-between mt-4">
                                <h1>NEXTJS</h1>
                                <p>75%</p>
                            </div>
                            <ProgressBar animated now={75} />
                        </div>
                        <div>
                            <div className="d-flex text-white justify-content-between mt-4">
                                <h1>MONGODB</h1>
                                <p>80%</p>
                            </div>
                            <ProgressBar animated now={80} />
                        </div>
                        <div>
                            <div className="d-flex text-white justify-content-between mt-4">
                                <h1>NODEJS</h1>
                                <p>95%</p>
                            </div>
                            <ProgressBar animated now={95} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Skills;